import type { TabsProps } from 'antd';
import { Tabs, Button } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HotkeysPreferences } from '../';
// import ServerLoad from '../ServerLoad';
import useWindowSize from '@vindr/utils/hooks/useWindowSize';

const UserPreferences = ({
  availableLanguages,
  defaultLanguage,
  currentLanguage,
  disabled,
  hotkeyDefinitions,
  hotkeyDefaults,
  onCancel,
  onSubmit,
  onReset,
  hotkeysModule,
  userAuthenticationService,
}) => {
  const { t } = useTranslation('ViewerTool');
  const [state, setState] = useState({
    isDisabled: disabled,
    hotkeyErrors: {},
    hotkeyDefinitions,
    language: currentLanguage,
  });

  const onSubmitHandler = () => {
    onSubmit(state);
  };

  const onResetHandler = () => {
    setState((state) => ({
      ...state,
      language: defaultLanguage,
      hotkeyDefinitions: hotkeyDefaults,
      hotkeyErrors: {},
      isDisabled: disabled,
    }));
    onReset();
  };

  const onCancelHandler = () => {
    setState({ hotkeyDefinitions });
    onCancel();
  };

  const onLanguageChangeHandler = (value) => {
    setState((state) => ({ ...state, language: value }));
  };

  const onHotkeysChangeHandler = (id, definition, errors) => {
    setState((state) => ({
      ...state,
      isDisabled: Object.values(errors).every(
        (e) => e !== '' && e !== undefined
      ),
      hotkeyErrors: errors,
      hotkeyDefinitions: {
        ...state.hotkeyDefinitions,
        [id]: definition,
      },
    }));
  };
  const { width } = useWindowSize();
  const queryParams = new URLSearchParams(location.search);
  const accessKey = queryParams.get('access_key');

  const items: TabsProps['items'] = [
    /* {
      key: '1',
      label: t('General'),
      children: !accessKey ? (
        <div className="mt-4 grid grid-cols-1 gap-x-10 gap-y-2 md:grid-cols-[max-content_1fr]">
          <div className="max-w-screen-md">
            <p>{t('Select server')}</p>
          </div>
          <div className="col-span-2 md:col-span-1">
            <ServerLoad userAuthenticationService={userAuthenticationService} />
          </div>
        </div>
      ) : null,
    }, */
    width > 640 && {
      key: '2',
      label: t('Hotkeys'),
      children: (
        <div className="mt-4 mb-8" title={t('Hotkeys')}>
          <HotkeysPreferences
            disabled={disabled}
            hotkeyDefinitions={state.hotkeyDefinitions}
            onChange={onHotkeysChangeHandler}
            errors={state.hotkeyErrors}
            hotkeysModule={hotkeysModule}
          />

          <div className="flex flex-row justify-between">
            <Button
              variant="outlined"
              border="light"
              onClick={onResetHandler}
              disabled={disabled}
            >
              {t('Reset to Defaults')}
            </Button>
            <div className="flex flex-row">
              <Button
                variant="outlined"
                border="light"
                onClick={onCancelHandler}
              >
                {t('Cancel')}
              </Button>
              <Button
                variant="contained"
                disabled={state.isDisabled}
                color="light"
                border="light"
                className="ml-2"
                onClick={onSubmitHandler}
              >
                {t('Save')}
              </Button>
            </div>
          </div>
        </div>
      ),
    },
  ].filter(Boolean);

  return (
    <div className="p-2">
      {/* <Section title={t('General')}>
        <div className="flex flex-row justify-center items-center w-72">
          <Typography variant="subtitle" className="mr-5 text-right h-full">
            {t('Language')}
          </Typography>
          <Select
            isClearable={false}
            onChange={onLanguageChangeHandler}
            options={availableLanguages}
            value={state.language}
          />
        </div>
      </Section> */}

      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

// const Section = ({ title, children }) => (
//   <>
//     <div className="mb-2 border-b-2 border-black">
//       <Typography
//         variant="h5"
//         className="flex grow pb-2 font-light text-primary-light"
//       >
//         {title}
//       </Typography>
//     </div>
//     <div className="mt-4 mb-8">{children}</div>
//   </>
// );

const noop = () => {};

UserPreferences.propTypes = {
  disabled: PropTypes.bool,
  hotkeyDefaults: PropTypes.object.isRequired,
  hotkeyDefinitions: PropTypes.object.isRequired,
  languageOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  hotkeysModule: PropTypes.shape({
    initialize: PropTypes.func.isRequired,
    pause: PropTypes.func.isRequired,
    unpause: PropTypes.func.isRequired,
    startRecording: PropTypes.func.isRequired,
    record: PropTypes.func.isRequired,
  }).isRequired,
};

UserPreferences.defaultProps = {
  languageOptions: [
    { value: 'ONE', label: 'ONE' },
    { value: 'TWO', label: 'TWO' },
  ],
  onCancel: noop,
  onSubmit: noop,
  onReset: noop,
  disabled: false,
};

export default UserPreferences;
